import React from 'react';
import { useSelector } from 'react-redux';

import SettingsContent from './contents/userSettingsContent';
import FormsContent from './contents/formsContent';
import Footer from './footer';
import Header from './header';
import { AUTHORIZED_CONTENT_TYPE_USER_SETTINGS } from './constants';

const AuthorizedState = () => {
  const selectedContentType = useSelector((store) => store.authorizedState.get('selectedContentType'));
  const isSettingsContentType = selectedContentType === AUTHORIZED_CONTENT_TYPE_USER_SETTINGS;
  let containerClassNames = 'container-fluid main-container';

  if (isSettingsContentType) { containerClassNames += ' user-settings-content'; }

  return (
    <div className="authorized-state">
      <Header />
      <div className={containerClassNames}>
        <Choose>
          <When condition={selectedContentType === AUTHORIZED_CONTENT_TYPE_USER_SETTINGS}>
            <SettingsContent />
          </When>
          <Otherwise>
            <FormsContent />
          </Otherwise>
        </Choose>
      </div>
      <Footer />
    </div>
  );
};

export default AuthorizedState;
